import Game from "../../Game.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";
import StandardSheetAnimations from "./StandardSheetAnimations.js";

export default class Goblin extends Mob {
	constructor(sprites, infoable=true) {
		super(sprites, StandardSheetAnimations.getAnimation("goblin"));
		this.substAnimation("idle_e", 1, { row: 9, col: 0 });
		this.substAnimation("idle_w", 1, { row: 9, col: 0 });
		this.substAnimation("idle_n", 1, { row: 10, col: 0 });


		this.width = Game.ENEMY_WIDTH;
		this.height = Game.ENEMY_HEIGHT;

		let traits = {
			clas: "enemy",
			race: "goblin",
			openDoors: true,
			static: false,
			qi: BasicAI.QI_MEDIUM,
			speed: Goblin.WALK_STEP * Game.MULT,
			radius: Goblin.RADIUS,
			runspeed: Goblin.RUN_STEP * Game.MULT,
			timeWarns: Goblin.TIME_WARNS,
			infoable: infoable
		}
		this.setMobTraits(traits)
	}
	init() {
		this.mc = jQuery("#template-mob").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}

}
Goblin.RADIUS = 5;
Goblin.WALK_STEP = 2;
Goblin.RUN_STEP = 4;
Goblin.TIME_WARNS = [300, 500];

